module.exports = __webpack_public_path__ + "img/ROSE_APPLE.68d2b5bd.png";